import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'planejamento-material');

const planejamentoMaterialActions = {
  ...genericActions(basePath),
  listarFiltrado: { method: 'GET', url: `${basePath}?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}` },
  buscar: { method: 'GET', url: `${basePath}/{id}` },
};

export default resource => resource(`${basePath}`, {}, planejamentoMaterialActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/planejamento-material.js